import React from "react";
import { Image, Stack } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import "./SaveHyperOnAndroid.scss";
import BottomDrawer from "../../BottomDrawer/BottomDrawer";
import PrimaryActionButton from "../../Buttons/PrimaryActionButton/PrimaryActionButton";
import { usePwaContext } from "../../../context/pwa-context";
import { setStoredPwaInstallOrigin } from "../../../utils/storage";
import { SaveHyperModalProps } from "../types";
import { ThemeVariant } from "../../../utils/constants/generic-types";
import ImageSaveHyperScreenshot from "../../../images/save-hyper-screenshot.png";

export default function SaveHyperOnAndroid({
  isOpen,
  onClose,
  theme,
}: SaveHyperModalProps) {
  const { t } = useTranslation("common");
  const { promptUserToInstall } = usePwaContext();

  const handleSaveHyper = () => {
    const { pathname } = window.location;
    promptUserToInstall();
    setStoredPwaInstallOrigin(pathname);
    onClose();
  };

  return (
    <BottomDrawer
      isOpen={isOpen}
      onClose={onClose}
      containerClass={`SaveHyperOnAndroidModal ${
        theme === ThemeVariant.DARK ? "Dark" : ""
      }`}
    >
      <Stack className="py-3 SaveHyperOnAndroidContent">
        <Stack gap={2} className="text-center Copy">
          <Image src={ImageSaveHyperScreenshot} />
          <h2 className="fs-6 Hanson-700 SpecialFontSettings Heading">
            {t(
              "notifications.add_hyper_web_to_home_screen_to_turn_on_notifications"
            )}
          </h2>
          <p className="Grotesk SpecialFontSettings SubText">
            {t("notifications.app_size_1_mb")}
          </p>
        </Stack>
        <Stack className="Ctas">
          <PrimaryActionButton
            size="lg"
            text={t("notifications.add_to_home_screen")}
            onClick={handleSaveHyper}
          />
          <button
            className="Grotesk SpecialFontSettings SecondaryCta"
            onClick={onClose}
          >
            {t("remind_me_later")}
          </button>
        </Stack>
      </Stack>
    </BottomDrawer>
  );
}
